export default "__VITE_ASSET__B$sqE5DS__"